export default __webpack_public_path__ + "0b349e111a65fd5dec09d5cc4f284902.png";